/**
 * LumynLogo — refined login-surface brand lockup.
 *
 * A monoline lightbulb-with-filament glyph paired with the lumyn wordmark.
 * Lighter weight than the previous "emoji-style" mark — reads as a real
 * brand at small sizes. Defaults to white-on-dark; pass `tone="dark"` for
 * navy-on-light surfaces.
 */
export default function LumynLogo({ size = 36, tone = 'light', className = '' }) {
  const stroke = tone === 'dark' ? '#0E1B3D' : '#FFFFFF';
  const accent = '#FBBF24';
  const wordmark = tone === 'dark' ? '#0E1B3D' : '#FFFFFF';
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="lumyn-logo">
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        {/* Bulb outline */}
        <path
          d="M16 5 C11.6 5 8 8.4 8 12.6 C8 15 9.2 16.9 10.8 18.1 L10.8 21 L21.2 21 L21.2 18.1 C22.8 16.9 24 15 24 12.6 C24 8.4 20.4 5 16 5 Z"
          fill="none"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        {/* Filament */}
        <path
          d="M12.5 12 L14.5 14.5 L16 12 L17.5 14.5 L19.5 12"
          fill="none"
          stroke={accent}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Base ridges */}
        <path
          d="M11.5 22.5 L20.5 22.5 M12.5 24.5 L19.5 24.5 M14 26.5 L18 26.5"
          stroke={stroke}
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        {/* Glow dot */}
        <circle cx="22.5" cy="6.5" r="1.6" fill={accent} />
      </svg>
      <span
        className="text-[1.35rem] font-semibold tracking-[1.5px] leading-none lowercase"
        style={{ color: wordmark, fontFeatureSettings: '"ss01"' }}
      >
        lumyn
      </span>
    </div>
  );
}
